module.exports = __webpack_public_path__ + "img/BJ.8c2d849d.svg";